<app-gradient class="gradient gradient__left"></app-gradient>
<app-gradient class="gradient gradient__right"></app-gradient>
<div class="product-categories">
  <img
    class="product-categories__corner-image"
    alt="corner"
    loading="lazy"
    [src]="image" />
  <div class="product-categories__header">
    <h3 class="heading-m product-categories__title">
      {{ title }}
    </h3>
    <p class="body-l product-categories__description">
      {{ description }}
    </p>
  </div>

  <div class="product-cards__wrapper">
    @for (category of productCategories; track category) {
      <div
        (mouseover)="activateCard(category.title)"
        (click)="redirectLink(category.url)"
        [class.product-card--active]="activeCard === category.title"
        class="product-card">
        <div
          class="product-card__background"
          appBgImgFallback
          [primaryBgImageUrl]="category.image"
          [fallbackBgImageUrl]="category.image"></div>
        <app-button
          class="product-card__button"
          size="medium"
          [buttonTextSize]="activeCard === category.title ? 'body-m' : 'body-s'"
          type="secondary"
          text="{{ category.title }}">
        </app-button>
      </div>
    }
  </div>
</div>
